import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from '@atmi/core/guards/auth-guard.service';
import { RoleGuardService } from '@atmi/core/guards/role-guard.service';
import { RoleResolverService } from '@atmi/core/resolvers/role-resolver.service';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    canActivate: [AuthGuardService],
    data: {
      authenticated: false,
    },
    loadChildren: () => import('./pages/noauth/noauth.module').then(m => m.NoauthModule),
    path: '',
  },
  {
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      authenticated: true,
    },
    loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule),
    path: '',
    resolve: {
      role: RoleResolverService,
    },
  },
  {
    path: '**',
    redirectTo: 'login', // FIXME: check authentication state
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
})
export class AppRoutingModule { }
